import { render, staticRenderFns } from "./Borders.vue?vue&type=template&id=1719a226&scoped=true&"
import script from "./Borders.vue?vue&type=script&lang=js&"
export * from "./Borders.vue?vue&type=script&lang=js&"
import style0 from "./Borders.vue?vue&type=style&index=0&id=1719a226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1719a226",
  null
  
)

export default component.exports